<template>
  <div v-if="moveContactStage.nextStage.value">
    <ButtonGroup>
      <Button
        data-track="clicked-primary-contact-stage-update-button"
        class="whitespace-nowrap"
        @click="handleStageChange(moveContactStage.nextStage.value)"
      >
        Move to {{ moveContactStage.nextStage.value }}
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger as-child>
          <Button class="px-2">
            <span class="sr-only">Other options</span>
            <vue-feather type="chevron-down" class="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel>Stages</DropdownMenuLabel>
          <DropdownMenuItem
            v-for="stageOption in primaryStages"
            :key="stageOption"
            :disabled="stageOption === contact.stage"
            class="flex items-center justify-between"
            @select="handleStageChange(stageOption)"
          >
            <span>Move to {{ stageOption }}</span>
            <Badge v-if="stageOption === contact.stage" variant="gray">Current</Badge>
            <Badge v-else-if="stageOption === moveContactStage.nextStage.value" variant="indigo">Next</Badge>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuLabel>Other</DropdownMenuLabel>
          <DropdownMenuItem
            v-for="stageOption in terminalStages"
            :key="stageOption"
            :disabled="stageOption === contact.stage"
            class="flex items-center justify-between"
            @select="handleStageChange(stageOption)"
          >
            <span>Move to {{ stageOption }}</span>
            <Badge v-if="stageOption === contact.stage" variant="gray">Current</Badge>
            <Badge v-else-if="stageOption === moveContactStage.nextStage.value" variant="indigo">Next</Badge>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </ButtonGroup>
  </div>
</template>

<script setup lang="ts">
import type { ContactStage } from '@/api/entity_types/Contact';
import type { UseMoveContactStageReturn } from './useMoveContactStage';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ButtonGroup } from '@/components/ui/button-group';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

type Props = {
  contact: { id: number; stage: ContactStage };
  moveContactStage: UseMoveContactStageReturn;
};
const props = defineProps<Props>();

const TERMINAL_STAGES: ContactStage[] = ['Hired', 'Nurture'];

const primaryStages = props.moveContactStage.stageOptions.filter(s => !TERMINAL_STAGES.includes(s));
const terminalStages = props.moveContactStage.stageOptions.filter(s => TERMINAL_STAGES.includes(s));

const handleStageChange = (stage: ContactStage) => {
  emit('stage-selected', stage);
};

const emit = defineEmits<{ 'stage-selected': [newStage: ContactStage] }>();
</script>
